import { render, staticRenderFns } from "./ComissaoConsultor.vue?vue&type=template&id=bbda16a4&scoped=true"
import script from "./ComissaoConsultor.vue?vue&type=script&lang=js"
export * from "./ComissaoConsultor.vue?vue&type=script&lang=js"
import style0 from "./ComissaoConsultor.vue?vue&type=style&index=0&id=bbda16a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbda16a4",
  null
  
)

export default component.exports